import { render, staticRenderFns } from "./UserFilters.vue?vue&type=template&id=8151f2ce&scoped=true"
import script from "./UserFilters.vue?vue&type=script&lang=js"
export * from "./UserFilters.vue?vue&type=script&lang=js"
import style0 from "./UserFilters.vue?vue&type=style&index=0&id=8151f2ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8151f2ce",
  null
  
)

export default component.exports